export const atSign = '@';
export const optional = '?';
export const or = '|';
export const zeroOrMore = '*';
export const NAME_REGEX = new RegExp("^(?![ '\\-.,/])(?:[\\p{L}\\p{M}]['\\-.,/]? ?)*[\\p{L}\\p{M}]$", "u");
export const LAST_NAME_REGEX = new RegExp(
  "^(?:-$|(?!(?:[ '\\-.,/]))(?:[\\p{L}\\p{M}](?:['\\-.,/]? ?)?)*[\\p{L}\\p{M}])$", "u");
export const NO_XSS_REGEX = new RegExp(
  '^(?!.*(<|>|\\{|\\};|&lt|&gt)).*$',
  'u'
);